import {getSettlementDetail} from '@web/actions/saleSettlement'
import {getInitialState} from '@web/slices/orderClaimInfo/slice'
import makeSlice from '@web/slices/orderClaimInfo/sliceMaker'

const orderClaimInfoSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getSettlementDetail.pending, getInitialState)
            .addCase(getSettlementDetail.fulfilled, (state, {payload}) => {
                const {settleAmount} = payload
                state.status = 'ENABLE'
                state.summary = {
                    type: 'SETTLEMENT',
                    amount: settleAmount,
                }
                state.claimDetail = {
                    status: 'ENABLE',
                    title: '총 정산금액',
                    // 원건/취소건별 정산금액 노출
                    amount: settleAmount,
                    items: [{type: 'PRODUCT', amount: settleAmount}],
                }
            })
    },
})

export default orderClaimInfoSlice.reducer
